import type { ObjectType } from '@quromedical/fhir-common';
import * as yup from 'yup';

import type { EWSAlertCommentCreateRequest } from './schema';

export const alertCommentCreateSchema = yup
  .object<ObjectType<EWSAlertCommentCreateRequest>>({
    alertTs: yup.number().positive().required(),
    classification: yup.string().required(),
    details: yup.string().optional(),
    quality: yup.string().required(),
  })
  .required();
